<template>
  <div> 
    <div class='glitchHolder'>
      <div v-if="glitches" id="glitchOverlay" :style="{top:glitchTop+'px'}">
        <div v-for="g in glitches" class='glitchOver' :style="{marginBottom:g.pad+'px',width:g.width+'%'}">
        <div v-for="gc in g.child" class='glitchChild' :style="{backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'}"></div>
        </div>
      </div>
    </div>
    <v-container ma-0 pt-0  >
      <v-layout >
        <v-flex xs12 class="text-xs-center">
          <v-progress-circular indeterminate :size="50" 
            color="grey" 
            :width="7" 
            v-if="loading"></v-progress-circular>
        </v-flex>
      </v-layout>    
      <v-layout>
        <v-flex xs12 offset-xs0 sm10 offset-sm2 pa-2 >
         
           <v-img  :src="'https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FWeAreOne-crop.png?alt=media&token=a6539c27-6222-4c52-9f91-e27229b308c1'"  width="100%" style="margin-top:10px;margin:auto;position:relative" @click="showBars=!showBars"></v-img>
          
         
          
          <br> <br>
          <h2>We Are One at The Loop</h2>
         
<h4>Friday June 5, 2020
4:30pm - 9:15pm
@ The Loop
<br>
157 Elizabeth Street, Hobart.
Outdoor courtyard<br>
          
        
           </h4>
 <br>

<h3>HOBART comes out of cultural hibernation with a special screening at The Loop.</h3>
<p>
This Friday, The Loop screens highlights from The We Are One Global Film Festival, a historic film event from international film festivals during lock-down.
</p>
 
<p>
This will be a free socially-distanced outdoor cinema experience showing a double feature and short films from the We Are One Global Film Festival.</p>

<p>
Rug up and get cosy under the heaters and join us for a taste of the crème de la crème of international cinema talent. A warm invite is extended to the general public, UTAS residents and students are warmly invited to attend. There'll be heaters and beanbags. BYO warm things and snacks.
</p>
<p>
All welcome.
Bookings recommended via Eventbrite - <a href="https://www.eventbrite.com.au/e/we-are-one-at-the-loop-tickets-107787605630" target="blank">Book here</a><br>
Drop-ins welcome,  however there will be a 20-person capacity on a first-come-first-serve basis.
</p>
<h3>The program is proudly jointly presented by the City of Hobart and University of Tasmania.</h3>

        </v-flex> 
      </v-layout>
    </v-container>
  </div>
</template>

<script>
 export default {
   
   data () {
     return {
       glitches:null,
       glitchCount:20,
       glitchTop:0
     }
   },
   mounted(){
     this.glitches=[]
     let childA=[]  
      for(var i=0;i<8;i++){
        childA=[]
        for(var p=0;p<2;p++){
          childA.push(Math.floor(Math.random()*100));   
        }
        this.glitches.push({colour:'#00000044',height:30,pad:3,width:Math.random()*50+50,child:childA})
      }
      setTimeout(this.glitch,100);
   },
   computed: {
     loading () {
       return this.$store.getters.loading
     },
     userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
    
    },
   methods: {
     glitch(){

        this.glitchCount++
        if(this.glitchCount>50){
            this.glitchCount=Math.random()*20-10
            this.glitchTop=Math.random()*400+100;
        }
       if(this.glitchCount>10){
         this.glitchCount+=Math.random()*40
          setTimeout(this.glitch,Math.random()*100+100);
          
          return
         
       }
        
       
        for(var g in this.glitches){
          if(Math.random()*10>7){
            this.glitches[g].height=Math.random()*20+5;
            for(var gc in this.glitches[g].child){
                this.glitches[g].child[gc]=Math.floor(Math.random()*160+20);
            }
             if(Math.random()*10>5){
               this.glitches[g].height=0;
             }
          }
          this.glitches[g].pad=Math.floor(Math.random()*5+5)
          this.glitches[g].width=Math.floor(Math.random()*160+20) 
        }
        if(Math.random()*10>5){
         // this.glitchTop=Math.random()*400+100;
        }
        setTimeout(this.glitch,100);
     }
     
   }
 }
</script>

<style scoped>
  .glitchHolder{
    position: absolute;
    top: 0px;
    height: 100%;
    width: 100%;
    min-height: 100px;
    overflow: hidden;
    pointer-events: none;
  }
  #glitchOverlay{
  position:absolute;
  left:-100px;
  top:0px;
}
.glitchOver{
  
  z-index:3;
  position:relative;
  min-height:30px;
  pointer-events:none;
  opacity:0.3;
  width:400px;
  
}
.glitchChild{
  width:40px;
  display:inline-block;
  background-color:#00f;
}

</style>



// WEBPACK FOOTER //
// src/components/WeAreOne.vue